// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.View'
    , [
        'Calculator.SquareFoot.Square.View'
        , 'Calculator.SquareFoot.Rectangle.View'
        , 'Calculator.SquareFoot.Triangle.View'
        , 'Calculator.SquareFoot.Parallelogram.View'
        , 'Calculator.SquareFoot.Trapezoid.View'
        , 'Calculator.SquareFoot.Circle.View'
        , 'Calculator.SquareFoot.Ellipse.View'
        , 'Calculator.SquareFoot.Sector.View'

        , 'calculator_square_foot.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        CalculatorSquareFootSquareView
        , CalculatorSquareFootRectangleView
        , CalculatorSquareFootTriangleView
        , CalculatorSquareFootParallelogramView
        , CalculatorSquareFootTrapezoidView
        , CalculatorSquareFootCircleView
        , CalculatorSquareFootEllipseView
        , CalculatorSquareFootSectorView

        , calculator_square_foot_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_tpl

            , initialize: function (options) {

                this.container = options.container;
                this.isMainPage = options.isMainPage;

                this.layoutComponent = this.container.getComponent('Layout');

                //Initial Shape View
                var shape = 'square';
                var squareFootFormView = this.getFormType(shape);
                this.initialView = this.layoutComponent.addChildView('SquareFoot.Form', function () {
                    return squareFootFormView;
                });

            }

            , events: {
                'click [data-action="change-square-foot-view"]': 'getSquareFootView',
                'click [data-action="change-shape-view"]': 'changeShapeView'
            }

            , getSquareFootView: function getSquareFootView(event) {
                var self = this;

                this.layoutComponent.removeChildView('SquareFoot.Form', this.initialView);

                var el = this.$(event.target);
                var shape = el.attr("value");

                var squareFootFormView = this.getFormType(shape);

                var childView = this.layoutComponent.addChildView('SquareFoot.Form', function () {
                    return squareFootFormView;
                });

                self.render();

                this.layoutComponent.removeChildView('SquareFoot.Form', childView);
            }

            , changeShapeView: function changeShapeView() {

                this.layoutComponent.removeChildView('SquareFoot.Form', this.initialView);

            }
            
            , getFormType: function getFormType(shape) {
                if (shape == 'square') {
                    return new CalculatorSquareFootSquareView();
                } else if (shape == 'rectangle') {
                    return new CalculatorSquareFootRectangleView();
                } else if (shape == 'triangle') {
                    return new CalculatorSquareFootTriangleView();
                } else if (shape == 'parallelogram') {
                    return new CalculatorSquareFootParallelogramView();
                } else if (shape == 'trapezoid') {
                    return new CalculatorSquareFootTrapezoidView();
                } else if (shape == 'circle') {
                    return new CalculatorSquareFootCircleView();
                } else if (shape == 'ellipse') {
                    return new CalculatorSquareFootEllipseView();
                } else if (shape == 'sector') {
                    return new CalculatorSquareFootSectorView();
                }
            }

            , getContext: function getContext()
            {
                return {
                    isMainPage : this.isMainPage ? this.isMainPage : false
                }
            }
        });
    });
